import { Dispatch } from 'redux';
import { GiftCardTypes } from './Types';
import { ApiEndpoints, ActionHandler } from 'Utils';

export const getGiftCardDetails = (activationCode:string) => (dispatch: Dispatch) => {
	// const url = ApiEndpoints.giftMembership + ${`/activationCode`}
	return ActionHandler(
		{ url: `${ApiEndpoints.giftMembership}/${activationCode}`, method: 'GET', dispatch },

		(res) => {
			const { data } = res.data;

			dispatch({ type: GiftCardTypes.LOAD_GIFTCARD, payload: { data } });
		},
		(error) => {
            // eslint-disable-next-line 
            console.log(error)
			dispatch({ type: GiftCardTypes.GIFTCARD_ERROR, payload: { errors: error } });
		},
	);
};

export const activateGiftCardDetails = (token:string) => (dispatch: Dispatch) => {
	// const url = ApiEndpoints.giftMembership + ${`/token`}
	return ActionHandler(
		{ url: `${ApiEndpoints.activategiftMembership}/${token}`, method: 'GET', dispatch },

		(res) => {
			const { data } = res.data;

			dispatch({ type: GiftCardTypes.LOAD_ACTIVATE_GIFTCARD });
		},
		(error) => {
            // eslint-disable-next-line 
            console.log(error)
			dispatch({ type: GiftCardTypes.GIFTCARD_ERROR, payload: { errors: error } });
		},
	);
};


export const addUserGiftCard = (fullName:string,
	email:string,
	password:string,
	childFullName:string,
	dateOfBirth:string,
	gender:string,
	gestation:string,
	address: string | undefined,
	city: string | undefined,
	state: string | undefined,
	zipCode: string | undefined,
	phoneNumber: string | undefined,
	shipping_address: string | undefined,
	shipping_city: string | undefined,
	shipping_state: string | undefined,
	shipping_zipCode: string | undefined,
	shipping_phoneNumber: string | undefined,
	giftCardId:string,
	checked?:boolean | undefined,
	
	) => (dispatch: Dispatch) => {
	// const url = ApiEndpoints.giftMembership + ${`/activationCode`}
	const dateOfBirthNew = new Date(dateOfBirth);

	const gestationStatus = gestation != 'Term' ? 'preterm' : 'term'
	const genderStatus = gender != 'BOY' ? 'FEMALE' : 'MALE'

	const data = JSON.stringify({
		name:fullName,
		email,
		password,
		childName:childFullName,
		childBirthDate:dateOfBirthNew,
		gestation:gestationStatus,
		gender:genderStatus,
		address,
		city,
		zipCode,
		state,
		phoneNumber,
		// // business address
		shipping_address,
		shipping_city,
		shipping_zipCode,
		shipping_state,
		shipping_phoneNumber,
		checked,
		giftCardId
		
	})

	return ActionHandler(
		{ url: ApiEndpoints.addUserEndpoint, method: 'POST',dispatch , data},

		(res) => {
			const { data } = res.data;

			dispatch({ type: GiftCardTypes.ADD_USER, payload: { data } });
		},
		(error) => {
			// const { data } = error.response;
            // eslint-disable-next-line 
            console.log(error)
			dispatch({ type: GiftCardTypes.GIFTCARD_ERROR, payload: { errors: error } });
		},
	);
};

